import { isValidEnumValue, isValidKey } from 'utils/tsHelpers';

import { EventInfo, EVENT_LABELS, SystemEventName, AssociatedEntity } from '../../../domain';
import { EVENT_DISPLAY_NAME_FORMATTERS } from '../constants';
import { getAssociatedEntityName } from './getAssociatedEntityName';

export const getEventDisplayName = (
  event: EventInfo,
  allLists: AssociatedEntity[],
  allChannels: AssociatedEntity[],
  allMessageTypes: AssociatedEntity[],
) => {
  const associatedEntityName = getAssociatedEntityName(
    event,
    allLists,
    allChannels,
    allMessageTypes,
  );

  if (isValidKey(event.eventType, EVENT_DISPLAY_NAME_FORMATTERS) && associatedEntityName)
    return EVENT_DISPLAY_NAME_FORMATTERS[event.eventType](associatedEntityName);

  if (isValidEnumValue(event.eventType, SystemEventName)) return EVENT_LABELS[event.eventType];

  if (event.eventType === 'customEvent' && event.eventName) return event.eventName;

  return event.eventType;
};
